import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading, setProgressDialog } from "../utility";
import { httpRequestFunc } from "../../../common/config/httpClient";
import { notificationSuccessMessage } from "../../../common/config/message";
import {
  cancelThaipostOrderApi,
  createThaipostOrderApi,
  printThaipostOrderApi,
  trackingThaipostOrderApi,
  updateThaipostTrackingOrderApi,
} from "../../../common/api/thaipostApi";
import { fetchAsyncOrder } from "../order/orderthunk";
import moment from "moment/moment";
import { fetchAsyncReportSipping } from "../report/reportThunk";

export const createAsyncThaipostOrder = createAsyncThunk(
  "thaipost/createAsyncThaipostOrder",
  async (data, baseThunk) => {
    baseThunk.dispatch(setProgressDialog(true));
    baseThunk.dispatch(setLoading({ loading: "LOADING" }));
    try {
      const response = await httpRequestFunc(
        baseThunk,
        createThaipostOrderApi(data.orderId, data.data)
      );
      baseThunk.dispatch(setProgressDialog(false));
      notificationSuccessMessage(
        "ส่งข้อมูลสร้าง Tracking แล้ว กรุณาตรวจสอบรายการสั่งซื้อ"
      );
      baseThunk.dispatch(setLoading({ loading: "SUCCESS" }));
      if (typeof data.callback !== `undefined`) {
        data.callback(false);
      }
      if (typeof data.filter !== `undefined`) {
        const f = { ...data.filter };
        f.start = moment(f.start).format("YYYY-MM-DD");
        f.end = moment(f.end).format("YYYY-MM-DD");
        baseThunk.dispatch(fetchAsyncReportSipping(f));
      }
      return response.data;
    } catch (e) {
      baseThunk.dispatch(setProgressDialog(false));
      baseThunk.dispatch(setLoading({ loading: "ERROR" }));
      console.log(e);
    }
  }
);

export const cancelAsyncThaipostOrder = createAsyncThunk(
  "thaipost/cancelAsyncThaipostOrder",
  async (data, baseThunk) => {
    baseThunk.dispatch(setProgressDialog(true));
    baseThunk.dispatch(setLoading({ loading: "LOADING" }));
    try {
      const response = await httpRequestFunc(
        baseThunk,
        cancelThaipostOrderApi(data.orderId)
      );
      baseThunk.dispatch(setProgressDialog(false));
      notificationSuccessMessage(
        "ส่งข้อมูลสร้าง Tracking แล้ว กรุณาตรวจสอบรายการสั่งซื้อ"
      );
      baseThunk.dispatch(setLoading({ loading: "SUCCESS" }));
      if (typeof data.filter !== `undefined`) {
        const f = { ...data.filter };
        f.start = moment(f.start).format("YYYY-MM-DD");
        f.end = moment(f.end).format("YYYY-MM-DD");
        baseThunk.dispatch(fetchAsyncReportSipping(f));
      }
      return response.data;
    } catch (e) {
      baseThunk.dispatch(setProgressDialog(false));
      baseThunk.dispatch(setLoading({ loading: "ERROR" }));
      console.log(e);
    }
  }
);
export const updateTrackingAsyncThaipostOrder = createAsyncThunk(
  "thaipost/updateTrackingAsyncThaipostOrder",
  async (data, baseThunk) => {
    baseThunk.dispatch(setProgressDialog(true));
    baseThunk.dispatch(setLoading({ loading: "LOADING" }));
    try {
      const response = await httpRequestFunc(
        baseThunk,
        updateThaipostTrackingOrderApi(data.update)
      );
      baseThunk.dispatch(setProgressDialog(false));
      notificationSuccessMessage("อัพเดตสถานะ Tracking แล้ว");
      baseThunk.dispatch(setLoading({ loading: "SUCCESS" }));
      baseThunk.dispatch(fetchAsyncOrder(data.filter));
      return response.data;
    } catch (e) {
      baseThunk.dispatch(setProgressDialog(false));
      baseThunk.dispatch(setLoading({ loading: "ERROR" }));
      console.log(e);
    }
  }
);

export const trackingAsyncThaipostOrder = createAsyncThunk(
  "thaipost/trackingAsyncThaipostOrder",
  async (data, baseThunk) => {
    baseThunk.dispatch(setProgressDialog(true));
    baseThunk.dispatch(setLoading({ loading: "LOADING" }));
    try {
      const response = await httpRequestFunc(
        baseThunk,
        trackingThaipostOrderApi(data.id)
      );
      baseThunk.dispatch(setProgressDialog(false));
      // notificationSuccessMessage("ส่งข้อมูลสร้าง Tracking แล้ว กรุณาตรวจสอบรายการสั่งซื้อ")
      baseThunk.dispatch(setLoading({ loading: "SUCCESS" }));
      return response.data;
    } catch (e) {
      baseThunk.dispatch(setProgressDialog(false));
      baseThunk.dispatch(setLoading({ loading: "ERROR" }));
      console.log(e);
    }
  }
);

export const printAsyncThaipostOrder = createAsyncThunk(
  "thaipost/printAsyncThaipostOrder",
  async (data, baseThunk) => {
    baseThunk.dispatch(setProgressDialog(true));
    baseThunk.dispatch(setLoading({ loading: "LOADING" }));
    try {
      const response = await httpRequestFunc(
        baseThunk,
        printThaipostOrderApi(data)
      );
      baseThunk.dispatch(setProgressDialog(false));
      notificationSuccessMessage(
        "ส่งข้อมูลสร้าง Tracking แล้ว กรุณาตรวจสอบรายการสั่งซื้อ"
      );
      baseThunk.dispatch(setLoading({ loading: "SUCCESS" }));
      return response.data;
    } catch (e) {
      baseThunk.dispatch(setProgressDialog(false));
      baseThunk.dispatch(setLoading({ loading: "ERROR" }));
      console.log(e);
    }
  }
);
